import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'ui-kit';
import { Typography } from '@mui/material';
import React from 'react';
import { inheritDataTestId } from 'ui-kit/lib/utils/dataTestId';
import { useTranslate } from '@/i18n';
import { useAppSelector } from '@/store/store.ts';

export interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  description: string;
  onSubmit: () => void;
  onClose: () => void;
}

export const ConfirmationDialog = ({
  title,
  description,
  onSubmit,
  onClose,
  open,
  ...props
}: ConfirmationDialogProps) => {
  const { t } = useTranslate('common');
  const loading = useAppSelector((s) => s.sessions.loading);
  return (
    <Dialog
      data-test-id={inheritDataTestId(props)}
      open={open}
      size={'xs'}
      onClose={onClose}
    >
      <DialogTitle
        data-test-id={inheritDataTestId(props, 'dialog-title')}
        onClose={onClose}
      >
        {title}
      </DialogTitle>
      <DialogContent pt={24} pb={12}>
        <Typography sx={{ typography: { xs: 'string/md' } }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions noBorder noStack>
        <Button
          onClick={onClose}
          variant={'outlined'}
          color={'secondary'}
          data-test-id={inheritDataTestId(props, 'no-button')}
          disabled={loading}
        >
          {t('NO')}
        </Button>
        <Button
          color={'secondary'}
          onClick={onSubmit}
          data-test-id={inheritDataTestId(props, 'yes-button')}
          disabled={loading}
        >
          {t('YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
